import { Box, IconButton, Menu, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { HELP_SUPPORT_PHONE } from "../TopHeader.constants";
import { useHeaderMenuAnchor } from "../useHeaderMenuAnchor";
import {
  getRailActionButtonActiveSx,
  menuPaperSx,
} from "../TopHeader.style";
import {
  HelpTriggerIcon,
  helpBodySx,
  helpCloseButtonSx,
  helpHeaderSx,
  helpMenuListSx,
  helpMenuWidthSx,
  helpPhoneSx,
  helpSectionLabelSx,
  helpTextSx,
  helpTitleSx,
} from "./HelpMenu.style";

const HelpMenu = () => {
  const { anchorEl, isOpen, handleToggle, handleClose, closeMenu } =
    useHeaderMenuAnchor("help");

  return (
    <>
      <IconButton
        onClick={handleToggle}
        aria-label="Help"
        title="Help"
        aria-haspopup="menu"
        aria-expanded={isOpen ? "true" : undefined}
        sx={getRailActionButtonActiveSx(isOpen)}
      >
        <HelpTriggerIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { ...menuPaperSx, ...helpMenuWidthSx } },
          list: { sx: helpMenuListSx },
        }}
      >
        <Box sx={helpHeaderSx}>
          <Typography component="h3" sx={helpTitleSx}>
            Help
          </Typography>
          <IconButton
            onClick={closeMenu}
            aria-label="Close help"
            sx={helpCloseButtonSx}
          >
            <Close />
          </IconButton>
        </Box>
        <Box sx={helpBodySx}>
          <Typography component="div" sx={helpSectionLabelSx}>
            Support
          </Typography>
          <Typography component="div" sx={helpTextSx}>
            For help call{" "}
            <Box component="span" sx={helpPhoneSx}>
              {HELP_SUPPORT_PHONE}
            </Box>
          </Typography>
        </Box>
      </Menu>
    </>
  );
};

export default HelpMenu;
